import { IConfig } from '@cian/config/shared';

import { useApplicationContext } from '../../../containers/ApplicationContext';

export function checkStarRatingEnabled(config: IConfig) {
  return Boolean(config.get<boolean>('Dailyrent.HotelsStarRatingFilter.Enabled'));
}

export function useStarRatingEnabled(): boolean {
  const { config } = useApplicationContext();

  return checkStarRatingEnabled(config);
}
